import * as types from './types';

const INITIAL_STATE = {
  truckRouteListData: [],
  truckRouteListDataLoading: false,
  truckRouteListDataLoadingError: null,
  printTruckRouteDetailLoading: false,
  printTruckRouteDetailLoadingError: null,
  deleteTruckRouteSuccess: null,
  deleteTruckRouteLoading: false,
  deleteTruckRouteLoadingError: null,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.GET_TRUCK_ROUTE_LIST:
      return { ...state, truckRouteListData: action.payload };
    case types.GET_TRUCK_ROUTE_LIST_LOADING:
      return { ...state, truckRouteListDataLoading: action.payload };
    case types.GET_TRUCK_ROUTE_LIST_LOADING_ERROR:
      return { ...state, truckRouteListDataLoadingError: action.payload };
    case types.CLEAR_TRUCK_ROUTE_LIST_ERROR:
      return {
        ...state,
        truckRouteListDataLoadingError: null,
        printTruckRouteDetailLoadingError: null,
        deleteTruckRouteLoadingError: null,
      };
    case types.PRINT_TRUCK_ROUTE_DETAIL_LOADING:
      return { ...state, printTruckRouteDetailLoading: action.payload };
    case types.PRINT_TRUCK_ROUTE_DETAIL_LOADING_ERROR:
      return { ...state, printTruckRouteDetailLoadingError: action.payload };
    case types.DELETE_TRUCK_ROUTE:
      return { ...state, deleteTruckRouteSuccess: action.payload };
    case types.DELETE_TRUCK_ROUTE_LOADING:
      return { ...state, deleteTruckRouteLoading: action.payload };
    case types.DELETE_TRUCK_ROUTE_LOADING_ERROR:
      return { ...state, deleteTruckRouteLoadingError: action.payload };
    case types.CLEAR_DELETE_TRUCK_ROUTE_SUCCESS:
      return { ...state, deleteTruckRouteSuccess: null };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/inventory/truckroutes/state/managetruckrouteslist/reducer.js